var map = {
	"./ActiveLifestyleCarrefour/receipt.svg": "199e",
	"./ActiveLifestyleCarrefour/register.svg": "1081",
	"./ActiveLifestyleCarrefour/reward.svg": "3455",
	"./ActiveLifestyleCarrefour/select.svg": "6f3f",
	"./ActiveLifestyleCora/receipt.svg": "0bbb",
	"./ActiveLifestyleCora/register.svg": "02ff",
	"./ActiveLifestyleCora/reward.svg": "65eb",
	"./ActiveLifestyleCora/select.svg": "941f",
	"./ActiveLifestyleMega/receipt.svg": "1180",
	"./ActiveLifestyleMega/register.svg": "afca",
	"./ActiveLifestyleMega/reward.svg": "5cd1",
	"./ActiveLifestyleMega/select.svg": "07d4",
	"./AjaxAxion2023/receipt.svg": "7573",
	"./AjaxAxion2023/register.svg": "9b8e",
	"./AjaxAxion2023/reward.svg": "8ccc",
	"./AjaxAxion2023/select.svg": "e6bb",
	"./Auchan2022/receipt.svg": "d13e",
	"./Auchan2022/register.svg": "c777",
	"./Auchan2022/reward.svg": "5f51",
	"./Auchan2022/select.svg": "724f",
	"./AutumnCleaning2022/receipt.svg": "307c",
	"./AutumnCleaning2022/register.svg": "7989",
	"./AutumnCleaning2022/reward.svg": "d492",
	"./AutumnCleaning2022/select.svg": "4ca3",
	"./Autumncleaning2023/receipt.svg": "81eb",
	"./Autumncleaning2023/register.svg": "f878",
	"./Autumncleaning2023/reward.svg": "aef8",
	"./Autumncleaning2023/select.svg": "658d",
	"./Carrefour2022/receipt.svg": "0666",
	"./Carrefour2022/register.svg": "b481",
	"./Carrefour2022/reward.svg": "df1e",
	"./Carrefour2022/select.svg": "c167",
	"./CarrefourAniversar2024/receipt.svg": "95a1",
	"./CarrefourAniversar2024/register.svg": "1b42",
	"./CarrefourAniversar2024/reward.svg": "1d6e",
	"./CarrefourAniversar2024/select.svg": "cd42",
	"./CarrefourAniversar2025/receipt.svg": "00d3",
	"./CarrefourAniversar2025/register.svg": "4642",
	"./CarrefourAniversar2025/reward.svg": "4fc7",
	"./CarrefourAniversar2025/select.svg": "6f50d",
	"./ColgateAugust2022/receipt.svg": "c8cd",
	"./ColgateAugust2022/register.svg": "0cd3",
	"./ColgateAugust2022/reward.svg": "4804",
	"./ColgateAugust2022/select.svg": "f593",
	"./ColgateCarrefour21Ani/receipt.svg": "f8ac",
	"./ColgateCarrefour21Ani/register.svg": "9628",
	"./ColgateCarrefour21Ani/reward.svg": "083d",
	"./ColgateCarrefour21Ani/select.svg": "30dd",
	"./ColgateCharcoal/receipt.svg": "c9b3",
	"./ColgateCharcoal/register.svg": "4873",
	"./ColgateCharcoal/reward.svg": "904f",
	"./ColgateCharcoal/select.svg": "4d15",
	"./ColgateElixirCarrefour2022/receipt.svg": "80d4",
	"./ColgateElixirCarrefour2022/register.svg": "449a",
	"./ColgateElixirCarrefour2022/reward.svg": "6089",
	"./ColgateElixirCarrefour2022/select.svg": "59b6",
	"./ColgateEquityCarrefourJan2022/factura.svg": "b359",
	"./ColgateEquityCarrefourJan2022/produse.svg": "6d5f",
	"./ColgateEquityCarrefourJan2022/register.svg": "27c0",
	"./ColgateEquityCarrefourJan2022/reward.svg": "ff88",
	"./ColgateIT/receipt.svg": "0b0d",
	"./ColgateIT/register.svg": "49c2",
	"./ColgateIT/reward.svg": "22f0",
	"./ColgateIT/select.svg": "bafa",
	"./ColgateKaufland2025/cashback.svg": "f2ec",
	"./ColgateKaufland2025/product.svg": "d66c",
	"./ColgateKaufland2025/receipt.svg": "2f0d",
	"./ColgateKaufland2025/register.svg": "d619",
	"./ColgateLLDP2025/receipt.svg": "0e1a",
	"./ColgateLLDP2025/register.svg": "050e",
	"./ColgateLLDP2025/reward.svg": "32d2",
	"./ColgateLLDP2025/select.svg": "b1f2",
	"./ColgateLidl2025/receipt.svg": "7687",
	"./ColgateLidl2025/register.svg": "0fab",
	"./ColgateLidl2025/reward.svg": "e765",
	"./ColgateLidl2025/select.svg": "b1c8",
	"./ColgateMax2023/receipt.svg": "1376",
	"./ColgateMax2023/register.svg": "0bee",
	"./ColgateMax2023/reward.svg": "3403",
	"./ColgateMax2023/select.svg": "bda3",
	"./ColgateMaxAuchan2023/receipt.svg": "03c8",
	"./ColgateMaxAuchan2023/register.svg": "fe77",
	"./ColgateMaxAuchan2023/reward.svg": "d7a4",
	"./ColgateMaxAuchan2023/select.svg": "94be",
	"./ColgateOHM2024/receipt.svg": "0b71",
	"./ColgateOHM2024/register.svg": "03cf",
	"./ColgateOHM2024/reward.svg": "0386",
	"./ColgateOHM2024/select.svg": "5cb0",
	"./ColgateOHMLDP2024/receipt.svg": "18ac",
	"./ColgateOHMLDP2024/register.svg": "df2c",
	"./ColgateOHMLDP2024/reward.svg": "d0120",
	"./ColgateOHMLDP2024/select.svg": "173b",
	"./ColgatePalmolive2023/receipt.svg": "7799",
	"./ColgatePalmolive2023/register.svg": "6640",
	"./ColgatePalmolive2023/reward.svg": "afd5",
	"./ColgatePalmolive2023/select.svg": "ad3c",
	"./ColgateSeptember2023/receipt.svg": "0e82",
	"./ColgateSeptember2023/register.svg": "76c3",
	"./ColgateSeptember2023/reward.svg": "bfcf",
	"./ColgateSeptember2023/select.svg": "fa55",
	"./ColgateSummer2023/receipt.svg": "9634",
	"./ColgateSummer2023/register.svg": "95e0",
	"./ColgateSummer2023/reward.svg": "14d1",
	"./ColgateSummer2023/select.svg": "38de",
	"./ColgateSummerKaufland2023/receipt.svg": "253f",
	"./ColgateSummerKaufland2023/register.svg": "187fc",
	"./ColgateSummerKaufland2023/reward.svg": "a406",
	"./ColgateSummerKaufland2023/select.svg": "98cc",
	"./ColgateTotal2023/receipt.svg": "583c",
	"./ColgateTotal2023/register.svg": "adad",
	"./ColgateTotal2023/reward.svg": "1b30",
	"./ColgateTotal2023/select.svg": "27f8",
	"./ColgateTotal2024/receipt.svg": "b7d1",
	"./ColgateTotal2024/register.svg": "8a5b",
	"./ColgateTotal2024/reward.svg": "7697",
	"./ColgateTotal2024/select.svg": "cac6",
	"./ColgateTotal2025/receipt.svg": "c83f",
	"./ColgateTotal2025/register.svg": "4f9d",
	"./ColgateTotal2025/reward.svg": "5bff",
	"./ColgateTotal2025/select.svg": "6b86",
	"./ColgateTotalActivePrevention2025/receipt.svg": "19af",
	"./ColgateTotalActivePrevention2025/register.svg": "1aff",
	"./ColgateTotalActivePrevention2025/reward.svg": "d0af",
	"./ColgateTotalActivePrevention2025/select.svg": "dadb",
	"./ColgateTotalCarrefour2022/receipt.svg": "b63b",
	"./ColgateTotalCarrefour2022/register.svg": "443e",
	"./ColgateTotalCarrefour2022/reward.svg": "0367",
	"./ColgateTotalCarrefour2022/select.svg": "2a0d",
	"./ColgateTotalDM2022/receipt.svg": "5cee",
	"./ColgateTotalDM2022/register.svg": "ef9f",
	"./ColgateTotalDM2022/reward.svg": "f290",
	"./ColgateTotalDM2022/select.svg": "cb88",
	"./ColgateTotalMegaImage2022/receipt.svg": "6491",
	"./ColgateTotalMegaImage2022/register.svg": "7217",
	"./ColgateTotalMegaImage2022/reward.svg": "2c93",
	"./ColgateTotalMegaImage2022/select.svg": "bc1f",
	"./ColgateUltra2023/receipt.svg": "c438",
	"./ColgateUltra2023/register.svg": "d7c6",
	"./ColgateUltra2023/reward.svg": "35bc",
	"./ColgateUltra2023/select.svg": "ea93",
	"./ColgateWhiteMoneyBack2024/receipt.svg": "5ef3",
	"./ColgateWhiteMoneyBack2024/register.svg": "7999",
	"./ColgateWhiteMoneyBack2024/reward.svg": "5b2a",
	"./ColgateWhiteMoneyBack2024/select.svg": "3e20",
	"./ColgateWhiteMoneyBack2025/receipt.svg": "39ac",
	"./ColgateWhiteMoneyBack2025/register.svg": "d160",
	"./ColgateWhiteMoneyBack2025/reward.svg": "21b2",
	"./ColgateWhiteMoneyBack2025/select.svg": "7231",
	"./ColgateWhitening2023/receipt.svg": "4513",
	"./ColgateWhitening2023/register.svg": "632c",
	"./ColgateWhitening2023/reward.svg": "cfab",
	"./ColgateWhitening2023/select.svg": "b160",
	"./ColgateWhitening2024/receipt.svg": "2f75",
	"./ColgateWhitening2024/register.svg": "8c7b",
	"./ColgateWhitening2024/reward.svg": "0925",
	"./ColgateWhitening2024/select.svg": "53e2",
	"./ColgateWhiteningAuchan2022/receipt.svg": "b4dd",
	"./ColgateWhiteningAuchan2022/register.svg": "e93f",
	"./ColgateWhiteningAuchan2022/reward.svg": "abe8",
	"./ColgateWhiteningAuchan2022/select.svg": "fe7e",
	"./ColgateWhiteningCarrefour2022/receipt.svg": "8949",
	"./ColgateWhiteningCarrefour2022/register.svg": "4121",
	"./ColgateWhiteningCarrefour2022/reward.svg": "7716",
	"./ColgateWhiteningCarrefour2022/select.svg": "a3ea",
	"./ColgateWhiteningSelgros2024/receipt.svg": "c963",
	"./ColgateWhiteningSelgros2024/register.svg": "64bd",
	"./ColgateWhiteningSelgros2024/reward.svg": "4d13",
	"./ColgateWhiteningSelgros2024/select.svg": "be7e",
	"./ColgateWomenDay2024/receipt.svg": "9631",
	"./ColgateWomenDay2024/register.svg": "85b6",
	"./ColgateWomenDay2024/reward.svg": "4b20",
	"./ColgateWomenDay2024/select.svg": "9f4f",
	"./ColgateWomenDay2025/receipt.svg": "c32f",
	"./ColgateWomenDay2025/register.svg": "34a3",
	"./ColgateWomenDay2025/reward.svg": "68cb2",
	"./ColgateWomenDay2025/select.svg": "292c",
	"./ColgateWomenDay2026/receipt.svg": "b6c4",
	"./ColgateWomenDay2026/register.svg": "d6ec",
	"./ColgateWomenDay2026/reward.svg": "bcb2",
	"./ColgateWomenDay2026/select.svg": "5755",
	"./Elmex-MB2023/receipt.svg": "5119",
	"./Elmex-MB2023/register.svg": "17ca",
	"./Elmex-MB2023/reward.svg": "0c2d",
	"./Elmex-MB2023/select.svg": "8a44",
	"./Elmex2023/receipt.svg": "be57",
	"./Elmex2023/register.svg": "9510",
	"./Elmex2023/reward.svg": "0c4a",
	"./Elmex2023/select.svg": "1a16",
	"./ElmexAuchanFeb2022/receipt.svg": "62da",
	"./ElmexAuchanFeb2022/register.svg": "60ea",
	"./ElmexAuchanFeb2022/reward.svg": "3ba7",
	"./ElmexAuchanFeb2022/select.svg": "76c7",
	"./ElmexAugust2022/receipt.svg": "6b7b",
	"./ElmexAugust2022/register.svg": "e139",
	"./ElmexAugust2022/reward.svg": "78cf",
	"./ElmexAugust2022/select.svg": "4a13",
	"./ElmexCarrefourFeb2022/receipt.svg": "842d",
	"./ElmexCarrefourFeb2022/register.svg": "d655",
	"./ElmexCarrefourFeb2022/reward.svg": "5d3d",
	"./ElmexCarrefourFeb2022/select.svg": "4e3a",
	"./ElmexCarrefourJuly2022/receipt.svg": "0610",
	"./ElmexCarrefourJuly2022/register.svg": "2a0e",
	"./ElmexCarrefourJuly2022/reward.svg": "5dde",
	"./ElmexCarrefourJuly2022/select.svg": "163d",
	"./ElmexIT2023/receipt.svg": "140f",
	"./ElmexIT2023/register.svg": "0770",
	"./ElmexIT2023/reward.svg": "0372",
	"./ElmexIT2023/select.svg": "5467",
	"./ElmexMegaFeb2022/receipt.svg": "b8b5a",
	"./ElmexMegaFeb2022/register.svg": "c893",
	"./ElmexMegaFeb2022/reward.svg": "b835",
	"./ElmexMegaFeb2022/select.svg": "8766",
	"./ElmexMoneyBack2024/receipt.svg": "4543",
	"./ElmexMoneyBack2024/register.svg": "46bd",
	"./ElmexMoneyBack2024/reward.svg": "9342",
	"./ElmexMoneyBack2024/select.svg": "1e69",
	"./ElmexMoneyBack2025/receipt.svg": "baf5",
	"./ElmexMoneyBack2025/register.svg": "29e3",
	"./ElmexMoneyBack2025/reward.svg": "3ab1",
	"./ElmexMoneyBack2025/select.svg": "e1b6",
	"./IngrijirePersonalaKaufland2025/receipt.svg": "883a",
	"./IngrijirePersonalaKaufland2025/register.svg": "40d3",
	"./IngrijirePersonalaKaufland2025/reward.svg": "4c25",
	"./IngrijirePersonalaKaufland2025/select.svg": "26e2",
	"./Ladyspeedstick2023/receipt.svg": "fde0",
	"./Ladyspeedstick2023/register.svg": "ea1f",
	"./Ladyspeedstick2023/reward.svg": "954a",
	"./Ladyspeedstick2023/select.svg": "fdaa",
	"./LidlBeauty2025/receipt.svg": "12a3",
	"./LidlBeauty2025/register.svg": "c4c1",
	"./LidlBeauty2025/reward.svg": "5250",
	"./LidlBeauty2025/select.svg": "5710",
	"./MegaImage2022/receipt.svg": "0b2c",
	"./MegaImage2022/register.svg": "2fdc",
	"./MegaImage2022/reward.svg": "0f50",
	"./MegaImage2022/select.svg": "efa2",
	"./Moneyback2022/receipt.svg": "13db",
	"./Moneyback2022/register.svg": "e06d",
	"./Moneyback2022/reward.svg": "40cb",
	"./Moneyback2022/select.svg": "ab8d",
	"./Palmolive2023/receipt.svg": "7d21",
	"./Palmolive2023/register.svg": "4d71",
	"./Palmolive2023/reward.svg": "82e4",
	"./Palmolive2023/select.svg": "b38c",
	"./PalmoliveCarrefourJune2022/receipt.svg": "b8a4",
	"./PalmoliveCarrefourJune2022/register.svg": "a34a",
	"./PalmoliveCarrefourJune2022/reward.svg": "f11a",
	"./PalmoliveCarrefourJune2022/select.svg": "eff8",
	"./PalmoliveChristmas2024/receipt.svg": "9bdb",
	"./PalmoliveChristmas2024/register.svg": "ed9f",
	"./PalmoliveChristmas2024/reward.svg": "e08c",
	"./PalmoliveChristmas2024/select.svg": "873f",
	"./PalmoliveExperentials2023/receipt.svg": "e9d7",
	"./PalmoliveExperentials2023/register.svg": "e53d",
	"./PalmoliveExperentials2023/reward.svg": "d908",
	"./PalmoliveExperentials2023/select.svg": "284d",
	"./PalmoliveLifestyle2024/receipt.svg": "9ed2",
	"./PalmoliveLifestyle2024/register.svg": "6527",
	"./PalmoliveLifestyle2024/reward.svg": "eaf1",
	"./PalmoliveLifestyle2024/select.svg": "1094",
	"./PalmoliveSmoothies2022/receipt.svg": "ad7f",
	"./PalmoliveSmoothies2022/register.svg": "cc49",
	"./PalmoliveSmoothies2022/reward.svg": "d581",
	"./PalmoliveSmoothies2022/select.svg": "9775",
	"./PalmoliveSummer2023/receipt.svg": "7b41d",
	"./PalmoliveSummer2023/register.svg": "b994",
	"./PalmoliveSummer2023/reward.svg": "e576",
	"./PalmoliveSummer2023/select.svg": "66c7",
	"./Protex2023/receipt.svg": "32bb",
	"./Protex2023/register.svg": "0ae2",
	"./Protex2023/reward.svg": "99c5",
	"./Protex2023/select.svg": "4126",
	"./Protex2024/receipt.svg": "96ed",
	"./Protex2024/register.svg": "9af6",
	"./Protex2024/reward.svg": "73ec",
	"./Protex2024/select.svg": "7677",
	"./ProtexCarrefour/factura.svg": "f191",
	"./ProtexCarrefour/register.svg": "58df",
	"./ProtexCarrefourJan2022/factura.svg": "85b7",
	"./ProtexCarrefourJan2022/produse.svg": "39c8",
	"./ProtexCarrefourJan2022/register.svg": "2d81",
	"./ProtexCarrefourJan2022/reward.svg": "e667",
	"./ProtexCharcoalCarrefour2022/receipt.svg": "bfa1",
	"./ProtexCharcoalCarrefour2022/register.svg": "44a3",
	"./ProtexCharcoalCarrefour2022/reward.svg": "3949",
	"./ProtexCharcoalCarrefour2022/select.svg": "0cfba",
	"./ProtexCharcoalCora2022/receipt.svg": "9934",
	"./ProtexCharcoalCora2022/register.svg": "f738",
	"./ProtexCharcoalCora2022/reward.svg": "8e77",
	"./ProtexCharcoalCora2022/select.svg": "01bc",
	"./ProtexCharcoalMega2022/receipt.svg": "e5d3",
	"./ProtexCharcoalMega2022/register.svg": "6444",
	"./ProtexCharcoalMega2022/reward.svg": "9802",
	"./ProtexCharcoalMega2022/select.svg": "0fe7",
	"./ProtexHealthProtection2023/receipt.svg": "576a",
	"./ProtexHealthProtection2023/register.svg": "5a27",
	"./ProtexHealthProtection2023/reward.svg": "10a7",
	"./ProtexHealthProtection2023/select.svg": "83bb",
	"./ProtexSummerCarrefour2022/receipt.svg": "a85a",
	"./ProtexSummerCarrefour2022/register.svg": "98a5",
	"./ProtexSummerCarrefour2022/reward.svg": "89ca",
	"./ProtexSummerCarrefour2022/select.svg": "c40b",
	"./ProtexSummerRomania/receipt.svg": "02d4",
	"./ProtexSummerRomania/register.svg": "870f",
	"./ProtexSummerRomania/reward.svg": "9c71",
	"./ProtexSummerRomania/select.svg": "a483",
	"./Protexcashback2025/cashback.svg": "9c5c",
	"./Protexcashback2025/product.svg": "7373",
	"./Protexcashback2025/receipt.svg": "5aaf",
	"./Protexcashback2025/register.svg": "b490",
	"./SpringCleaning2025/cashback.svg": "b322",
	"./SpringCleaning2025/product.svg": "647a",
	"./SpringCleaning2025/receipt.svg": "8823",
	"./SpringCleaning2025/register.svg": "7c87",
	"./SpringCleaningCarrefour2022/receipt.svg": "65df",
	"./SpringCleaningCarrefour2022/register.svg": "6498",
	"./SpringCleaningCarrefour2022/reward.svg": "f478",
	"./SpringCleaningCarrefour2022/select.svg": "4943",
	"./SpringCleaningCora2022/receipt.svg": "5f53",
	"./SpringCleaningCora2022/register.svg": "5280",
	"./SpringCleaningCora2022/reward.svg": "2edc",
	"./SpringCleaningCora2022/select.svg": "acb0",
	"./SpringCleaningMega2022/receipt.svg": "78e5",
	"./SpringCleaningMega2022/register.svg": "d478",
	"./SpringCleaningMega2022/reward.svg": "4556",
	"./SpringCleaningMega2022/select.svg": "da2a",
	"./Springcleaning2024/receipt.svg": "4454",
	"./Springcleaning2024/register.svg": "ee84",
	"./Springcleaning2024/reward.svg": "5403",
	"./Springcleaning2024/select.svg": "abed",
	"./SummerExperience2024/receipt.svg": "581d",
	"./SummerExperience2024/register.svg": "1d47",
	"./SummerExperience2024/reward.svg": "dd3d",
	"./SummerExperience2024/select.svg": "30e0",
	"./SummerJoy2025/receipt.svg": "a03e",
	"./SummerJoy2025/register.svg": "5d6e",
	"./SummerJoy2025/reward.svg": "ee36",
	"./SummerJoy2025/select.svg": "ca77",
	"./WomenDay2024/receipt.svg": "c4a0",
	"./WomenDay2024/register.svg": "3015",
	"./WomenDay2024/reward.svg": "c220",
	"./WomenDay2024/select.svg": "cfb2",
	"./WomenDay2025/cashback.svg": "f6e0",
	"./WomenDay2025/product.svg": "e120",
	"./WomenDay2025/receipt.svg": "a71c",
	"./WomenDay2025/register.svg": "b8f9",
	"./WomenDay2026/cashback.svg": "8c31",
	"./WomenDay2026/product.svg": "a42e",
	"./WomenDay2026/receipt.svg": "b808",
	"./WomenDay2026/register.svg": "400f",
	"./WomenDay2026/reward.svg": "644d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cb35";